import React, { useEffect, useState } from "react";
import { Button, Collapse } from "reactstrap";
import classnames from "classnames";
import Loader from "../../../components/Loader";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { Utils } from "helpers/utils";
import AppSimpleBar from "components/AppSimpleBar";
import TextBox from "components/TextBox";
import { getChatUserConversations2, toggleUserDetailsTab } from "../../../redux/actions";
// import { APIClient } from "api/apiCore";
import { searchChat as searchChatApi } from "../../../api/chats";
import UserAvatar from "components/UserAvatar";
import LoadingIconWithText from "components/LoadingIconWithText";


interface SearchChatsProps {
  display: boolean;
}
const SearchChats = ({ display }: SearchChatsProps) => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Chats,
    (state) => ({
      selectedChat: state.selectedChat,
    })
  );
  // Inside your component
  const {
    selectedChat
  } = useAppSelector(storeData);

  const [keyword, setKeyword] = useState<string>("");
  const [fetchPage, setFetchPage] = useState<number>(1);
  const [haveMorePage, setHaveMorePage] = useState<boolean>(false);
  const [searchResult, setSearchResult] = useState<any[]>([]);
  const [isSearching, setIsSearching] = useState<boolean>(false);

  useEffect(() => {
    setFetchPage(1);
    setHaveMorePage(false);
    setSearchResult([]);
  }, [selectedChat]);

  const onSearchNext = async () => {
    try {
      const nextPage = fetchPage + 1;
      setFetchPage(nextPage);
      onSearch(nextPage);
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onSearch = async (page: number) => {
    try {
      // console.log('search page = ' + page);
      // if (keyword.length < 2) {
      //   alert('กรุณาใส่คำค้นหา มากกว่า 2 ตัวอักษร')
      // } else {
      setHaveMorePage(false);
      setIsSearching(true);
      searchChatApi(selectedChat, page, keyword)
        .then((rs) => {
          if (rs.success) {
            setHaveMorePage(rs.data.length >= 20); /*20 = fetch size*/
            if (page == 1) {
              // console.log('data:', rs.data);
              setSearchResult(rs.data);
            } else {
              setSearchResult(prev => [...prev, ...rs.data]);
            }
          } else {
            alert(rs.message);
          }
          setIsSearching(false);
        })
        .catch((er) => {
          Utils.HandleException(er, true);
          setIsSearching(false);
        });
      // }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onFirstSeach = async () => {
    setFetchPage(1);
    onSearch(1);

  }

  const onKeyDown = (e: any) => {
    try {
      if (e.key === "Enter") {
        onFirstSeach();
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onClickSearchTitle = async (msgId: string, msgDateTime: any) => {
    try {
      dispatch(getChatUserConversations2(selectedChat, msgDateTime, null, true, msgId, null, "Click search title"));
      if (window.innerWidth < 576) {
        dispatch(toggleUserDetailsTab(false));
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  return (
    <div style={{ display: display ? "" : "none", padding: "24px" }}>
      <div className="row">
        <div className="col">
          <div className="input-group mb-3">
            <input type="text" className="form-control" placeholder="ใส่คำค้นหา" onKeyDown={onKeyDown} onChange={(e) => setKeyword(e.target.value)} ></input>
            <div className="input-group-append">
              <button className="btn btn-primary hande" onClick={onFirstSeach}>
                {isSearching ? (<LoadingIconWithText loadingText={""}></LoadingIconWithText>) : (<i className="fas fa-search"></i>)}
              </button>
            </div>
          </div>
        </div>
      </div>
      <AppSimpleBar className="erp-topics-container-xx1" style={{ maxHeight: "calc(100vh - 150px)" }}>
        <ul className="list-unstyled " >
          {searchResult.map((item: any, key: number) =>
            <li key={key}>
              <div className="d-flex align-items-center hover hand" onClick={() => onClickSearchTitle(item.msgId, item.sendDateTime)}>
                <div
                  className={classnames(
                    "chat-user-img",
                    "align-self-center",
                    "me-2",
                    "ms-0",
                    { online: false }
                  )}
                >
                  <UserAvatar
                    profileImage={item.profileImage}
                    bgColor={item.bgColor}
                    foreColor={item.foreColor}
                    abbrName={item.abbrName}
                    userId={item.senderId}
                  />
                </div>
                <div className="overflow-hidden">
                  <p className="text-truncate mb-0 last-chat-text">
                    <i>
                      <span>{(item.senderId == -1 || item.senderId == -2) ? "บอท" : item.displayName2}</span>
                      &nbsp;&nbsp;[{Utils.GetShortDateTimeToShowInChat(item.sendDateTime, true)}]
                    </i>
                  </p>
                  <p className="text-truncate mb-0 " dangerouslySetInnerHTML={{ __html: item.text }}>
                    {/* {item.text} */}
                  </p>
                </div>
                {/* <div className="ms-auto text-end">
                  <p className="text-truncate mb-0 " >
                    <span className={"last-chat-time p-1 "}>{Utils.GetShortDateTimeToShowInChat(item.sendDateTime, true)}</span>
                  </p>
                </div> */}
              </div>
            </li>
          )}
          {haveMorePage && (
            <li>
              <div className="d-flex align-items-center hover hand">
                {isSearching ? (
                  <LoadingIconWithText loadingText={"กำลังค้นหา..."}></LoadingIconWithText>)
                  : (
                    <button className="btn btn-sm btn-warning w-100 hand" onClick={onSearchNext}>
                      <i className="fas fa-angle-double-down"></i>
                      &nbsp;ค้นหาเพิ่มเติม&nbsp;
                      <i className="fas fa-angle-double-down"></i>
                    </button>
                  )}

              </div>
            </li>
          )}
        </ul>
      </AppSimpleBar>
    </div>
  )
}

export default SearchChats;
